/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/common-utils';
import {
  Button,
  Colors,
  Heading,
  Spacer,
  Typography,
} from '@zapier/design-system';

import Link from 'app/common/components/Link';
import {
  BASE_DOC_URL_VB,
  PARTNER_SOLUTIONS_BASE_DOC_URL,
} from 'app/developer-v3/constants';
import { SizeType } from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

// TODO: consume DocLinks, Section, and Surface from @zapier/product-get-help
// once it's exported from that package.
import DocLinks from './DocLinks';
import Section from './Section';
import Surface from './Surface';

const subheadingCss = css`
  ${Typography.Body1}
  font-weight: 700;
  color: ${Colors.PrimeBlack};
`;

const DOC_LINKS = [
  {
    title: 'Developer platform quickstart guide',
    href: `${BASE_DOC_URL_VB}/quickstart/how-zapier-works`,
  },
  {
    title: 'Making integration changes',
    href: `${BASE_DOC_URL_VB}/manage/planning-changes`,
  },
  {
    title: 'Partner program benefits',
    href: `${ZAPIER_APP_BASE_URL}/developer-platform/partner-program`,
  },
  {
    title: 'Plan your Zapier integration',
    href: `${BASE_DOC_URL_VB}/publish/public-integration`,
  },
  {
    title: 'Embed Zapier in your app and website',
    href: `${PARTNER_SOLUTIONS_BASE_DOC_URL}/getting-started`,
  },
  {
    title: 'Frequently asked questions',
    href: `${BASE_DOC_URL_VB}/build/faq`,
  },
];

type PartnerAdditionalHelpProps = {
  /** Custom title to use. */
  title?: string;
  /** Size to display. */
  size?: SizeType;
};

export const PartnerAdditionalHelp = ({
  size = 'large',
  title = 'Additional Help',
}: PartnerAdditionalHelpProps) => (
  <Section size={size} title={title}>
    <Surface size={size} title="Help Center">
      <p>
        For help with Zaps or general Zapier questions, visit our{' '}
        <Link href={`${ZAPIER_APP_BASE_URL}/help`} target="_blank">
          main help center
        </Link>
        .
      </p>
      <Spacer height={30} />
      <Heading css={subheadingCss}>
        Popular Platform and Partner Help Articles
      </Heading>
      <Spacer height={20} />
      <DocLinks links={DOC_LINKS} size={size} />
      <Spacer height={30} />
      <Button
        color="primary"
        href={`${BASE_DOC_URL_VB}/quickstart/how-zapier-works`}
        target="_blank"
      >
        Browse Platform Docs
      </Button>
    </Surface>
  </Section>
);
